import { GLOBAL_OBJ } from '@sentry/core';
/** Get's the global object for the current JavaScript runtime */
export const RN_GLOBAL_OBJ = GLOBAL_OBJ;
//# sourceMappingURL=worldwide.js.map